module.exports = __webpack_public_path__ + "img/编组备份 5.daa8da9d.png";